import { render, staticRenderFns } from "./NextCollapse.vue?vue&type=template&id=6ab62b80&scoped=true"
import script from "./NextCollapse.vue?vue&type=script&lang=js"
export * from "./NextCollapse.vue?vue&type=script&lang=js"
import style0 from "./NextCollapse.vue?vue&type=style&index=0&id=6ab62b80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab62b80",
  null
  
)

export default component.exports